// extracted by mini-css-extract-plugin
export default {"container":"platiqr_container__mvV-1","btnBlock":"platiqr_btnBlock__eYwNc","logo":"platiqr_logo__5sCY-"};